import { ArrowRight } from "lucide-react";

const TRANSFORMATIONS = [
  {
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/uzklex8i_IMG_8394.jpeg",
    title: "Bathroom Floor Transformation",
    type: "LVP Flooring · Bathroom Remodel",
  },
  {
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/7satbct7_IMG_8391.jpeg",
    title: "Kitchen Floor Transformation",
    type: "LVP Flooring · Kitchen Remodel",
  },
  {
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/x7m4cm17_IMG_8219.jpeg",
    title: "Marble Primary Bath",
    type: "Full Tile Remodel · Wentzville",
  },
  {
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/xo198ivi_IMG_8222.jpeg",
    title: "Espresso LVP Living Room",
    type: "Carpet-to-LVP · St. Peters",
  },
];

export default function BeforeAfter() {
  return (
    <section
      id="before-after"
      data-testid="before-after-section"
      className="py-16 lg:py-24 bg-stone-100"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-orange-600 font-semibold mb-6">
            <span className="h-px w-8 bg-orange-600" />
            The Transformation
          </div>
          <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.025em] text-stone-900">
            Before &amp; After.
            <br />
            <span className="text-stone-500">Real projects. Real results.</span>
          </h2>
          <p className="mt-6 text-lg text-stone-600 leading-relaxed max-w-2xl">
            The floor is the biggest surface in any room — and the fastest way
            to transform a space. See what a proper install can do.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          {TRANSFORMATIONS.map((t, i) => (
            <figure
              key={t.title}
              data-testid={`before-after-${i}`}
              className="group relative overflow-hidden rounded-2xl bg-white shadow-[0_10px_40px_-15px_rgba(0,0,0,0.15)] hover:shadow-[0_20px_60px_-20px_rgba(0,0,0,0.25)] transition-shadow duration-500"
            >
              <div className="relative overflow-hidden">
                <img
                  src={t.image}
                  alt={`M&L Exterior and Interior Design — ${t.title} before and after`}
                  loading="lazy"
                  className="w-full h-auto object-cover group-hover:scale-[1.02] transition-transform duration-700 ease-out"
                />
              </div>
              <figcaption className="p-6 lg:p-7 flex items-start justify-between gap-4">
                <div>
                  <div className="font-display text-lg lg:text-xl font-semibold text-stone-900 leading-tight">
                    {t.title}
                  </div>
                  <div className="mt-1 text-sm text-stone-500 font-medium">
                    {t.type}
                  </div>
                </div>
                <a
                  href="#contact"
                  data-testid={`before-after-cta-${i}`}
                  aria-label={`Get a quote like ${t.title}`}
                  className="shrink-0 mt-1 w-11 h-11 rounded-full bg-stone-900 text-stone-50 flex items-center justify-center hover:bg-orange-600 transition-colors"
                >
                  <ArrowRight size={17} />
                </a>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* CTA below the grid */}
        <div className="mt-16 text-center">
          <p className="text-stone-600 text-lg mb-6">
            Want a transformation like this in your home?
          </p>
          <a
            href="#contact"
            data-testid="before-after-quote-cta"
            className="inline-flex items-center gap-2 px-7 py-4 bg-stone-900 text-stone-50 text-sm font-semibold rounded-full hover:bg-orange-600 transition-colors duration-300 group"
          >
            Get a Free Quote
            <ArrowRight
              size={15}
              className="group-hover:translate-x-0.5 transition-transform"
            />
          </a>
        </div>
      </div>
    </section>
  );
}
